{
  "mappings": [
    {
      "category": "Registration Information",
      "titles": ["Email Addresses.csv", "PhoneNumbers.csv", "Registration.csv"]
    },
    {
      "category": "Profile Information",
      "titles": [
        "Education.csv",
        "Honors.csv",
        "Languages.csv",
        "Positions.csv",
        "Profile.csv",
        "Profile Summary.csv",
        "Skills.csv"
      ]
    },
    {
      "category": "User-Provided Content",
      "titles": ["Jobs", "Saved Jobs.csv", "SavedJobAlerts.csv", "User-Provided Content"]
    },
    {
      "category": "Calendar Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "User-Generated Content",
      "titles": ["Rich_Media.csv", "Notes.csv", "Projects.csv", "Reactions_1190571946.csv"]
    },
    {
      "category": "Public Information",
      "titles": ["Honors.csv", "Public Information"]
    },
    {
      "category": "Contact and Calendar Information",
      "titles": ["Email Addresses.csv", "PhoneNumbers.csv", "Invitations.csv", "Connections.csv"]
    },
    {
      "category": "Partner-Provided Information",
      "titles": ["Positions.csv", "Jobs", "Job Seeker Preferences.csv"]
    },
    {
      "category": "Service Use Information",
      "titles": ["Ad_Targeting.csv", "Inferences_about_you.csv"]
    },
    {
      "category": "Cookies and Similar Technologies",
      "titles": ["Ad_Targeting.csv", "Inferences_about_you.csv"]
    },
    {
      "category": "Device and Location Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Communication Information",
      "titles": [
        "guide_messages.csv",
        "learning_coach_messages.csv",
        "learning_role_play_messages.csv",
        "messages.csv",
        "Invitations.csv",
        "Connections.csv"
      ]
    },
    {
      "category": "Workplace and School Provided Information",
      "titles": ["Education.csv", "Positions.csv"]
    },
    {
      "category": "Sites and Services of Others",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Payment Information",
      "titles": ["no_matching_file"]
    }
  ]
}
